export const path = "/master-design-aluna";
export const component = () => import("./index.jsx");
export const sidebar = {
  title: "MASTER DESIGN",
  section: "ALUNA",
  group: null,
  order: 4,
  roles: [
    "Authenticated",
    "aluna",
    "aluna-management",
    "design",
    "design-roundler",
    "master-aluna-rrss",
    "roundler-admin",
    "aluna-afiliado",
  ],
};
